import { render, staticRenderFns } from "./investPlaceList.vue?vue&type=template&id=e6209462&"
import script from "./investPlaceList.vue?vue&type=script&lang=js&"
export * from "./investPlaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports